import React, { useState, useEffect, useContext } from "react";
import {
  Grid,
  Paper,
  FormControl,
  RadioGroup,
  Divider,
  Button,
  Box,
  Radio,
  FormControlLabel
} from "@material-ui/core";
import { useTranslation } from "../../langs/useTranslation";
import { SubmitBtnContext, NotificationContext } from "../../App";
import useStyles from "../../styles/delegationStyle";
import * as localforage from "localforage";
import * as $ from "jquery";
import StyledSubmitBtn from "../../components/commons/StyledSubmitBtn";
import { SendOutlined } from "@material-ui/icons";
import EditGroupsDialog from "./EditGroupsDialog";
import { getCompanyGroupsAPI } from "../../apis/getCompanyGroupsAPI";
import { getSubCompanyAPI } from "../../apis/getSubCompanyAPI";
import { assignDevicesAPI } from "../../apis/assignDevicesAPI";
import { removeDevicesAPI } from "../../apis/removeDevicesAPI";
import { updateDeviceNubisVersionAPI } from "../../apis/updateDeviceNubisVersionAPI";
import { updateDeviceStatusAPI } from "../../apis/updateDeviceStatusAPI";
import { uploadExistingDevicesAPI } from "../../apis/uploadExistingDevicesAPI";
import { table } from "../../helpers/delegationDatatable";
import DelegationActionFromOrToDeterminator from "./DelegationActionFromOrToDeterminator";
import ActionRadioGroup from "./ActionRadioGroup";
import SelectionMenuItem from "./SelectionMenuItem";
import { setUpArrayWithCheckStatus } from "../../helpers/setUpArrayWithCheckStatus";
import {
  StepTitle,
  SettingText,
  MissingSelectedErrorText
} from "../commons/StyledTexts";
import DelegationTable from "./DelegationTable";
import ExcelFileUpload from "../commons/ExcelFileUpload";
import { successfullyDelegationHandling } from "../../helpers/successfullyDelegationHandling";
import { handleDatatableSelectWithRadio } from "../../helpers/handleDatatableSelectWithRadio";
import HasPermission from "../commons/HasPermission";

const DelegationForm = () => {
  const classes = useStyles();
  const { t } = useTranslation("devicesGroups");
  const { dispatch } = useContext(SubmitBtnContext);
  const { getNotiDispatch } = useContext(NotificationContext);
  const [groups, setGroups] = useState([]);
  const [selectedGroups, setSelectedGroups] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [selectedCompanies, setSelectedCompanies] = useState([]);
  const [action, setAction] = useState("assign");
  const [selectWay, setSelectWay] = useState("select");
  const [excelFile, setExcelFile] = useState(null);
  const [selectedGroupIds, setSelectedGroupIds] = useState([]);
  const [selectedCompanyIds, setSelectedCompanyIds] = useState([]);
  const [deviceIds, setDeviceIds] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [deviceStatus, setDeviceStatus] = useState("");
  const [nubisVersion, setNubisVersion] = useState("");
  const [isMissingSelectedTarget, setIsMissingSelectedTarget] = useState(false);
  const [editGroupsDialogOpen, setEditGroupsDialogOpen] = useState(false);
  const [resetSearchField, setResetSearchField] = useState(true);
  const actionsHideGroupOrTagSelection = [
    "register",
    "nubis_free",
    "nubis_pro"
  ];
  let delegationTable = $("#device-list-table").DataTable();

  const handleSelectWayChange = e => {
    setSelectWay(e.target.value);
    setExcelFile(null); // reset the 'required' validation
    clearFileInput("#fileInput");
    setDeviceIds([]); // reset the 'required' validation
  };

  const getAllSelectionItems = async type => {
    if (type.includes("group")) {
      const companyGroupsArr = await getCompanyGroupsAPI();
      if (companyGroupsArr)
        setUpArrayWithCheckStatus(companyGroupsArr, setGroups, "group");
    }

    if (type.includes("company")) {
      await getSubCompanyAPI();
      const subCompaniesArr = await localforage.getItem("subCompanies");

      let subCompaniesArrWithNameAndId;
      if (subCompaniesArr)
        subCompaniesArrWithNameAndId = subCompaniesArr.map(o => ({
          name: o.title,
          id: o.key
        }));
      if (subCompaniesArrWithNameAndId)
        setUpArrayWithCheckStatus(
          subCompaniesArrWithNameAndId,
          setCompanies,
          "company"
        );
    }
  };

  const handleItemsSelected = (e, menuObjArray, chipObjArray, type) => {
    let itemName = e.target.name;
    let itemId = e.target.id;
    let itemCheckedStatus = e.target.checked;

    // update the menu list with checkbox status
    let changedItemIndex = menuObjArray.map(o => o.id).indexOf(itemId);
    let changedItem = {
      name: itemName,
      id: itemId,
      checked: itemCheckedStatus
    };

    const copiedItemsArr = menuObjArray;
    menuObjArray.splice(changedItemIndex, 1, changedItem);
    if (type === "group") setGroups([...copiedItemsArr]);
    if (type === "company") setCompanies([...copiedItemsArr]);

    // update the chip list
    let chipItem = {};
    chipItem["name"] = itemName;
    chipItem["id"] = itemId;

    let chipItemsIndex = chipObjArray.map(o => o.id).indexOf(itemId);
    chipItemsIndex > -1
      ? chipObjArray.splice(chipItemsIndex, 1)
      : chipObjArray.push(chipItem);
    if (chipObjArray.length > 0) setIsMissingSelectedTarget(false);

    // update the device table
    let selectedItemIds = chipObjArray.map(o => o.id);
    if (type === "group") {
      setSelectedGroups(chipObjArray);
      setSelectedGroupIds(selectedItemIds);
      table(
        t,
        action,
        selectedCompanyIds,
        selectedItemIds,
        deviceStatus,
        nubisVersion
      );
    }
    if (type === "company") {
      setSelectedCompanies(chipObjArray);
      setSelectedCompanyIds(selectedItemIds);
      table(
        t,
        action,
        selectedItemIds,
        selectedGroupIds,
        deviceStatus,
        nubisVersion
      );
    }
  };

  const handleReloadDataTable = () => {
    setResetSearchField(true);
    table(t, action, selectedCompanyIds, selectedGroupIds, nubisVersion);
  };

  const handleEditGroupsDialogClickOpen = () => setEditGroupsDialogOpen(true);

  const handleEditGroupsDialogClose = () => {
    setEditGroupsDialogOpen(false);
    getAllSelectionItems("group");
  };

  const handleResetGroupsAndCompanys = async () => {
    const resetGroupsCheckedArr = groups.map(o => ({
      name: o.name,
      id: o.id,
      checked: false
    }));
    const resetCompaniesCheckedArr = companies.map(o => ({
      name: o.name,
      id: o.id,
      checked: false
    }));
    await localforage.removeItem("dtDeviceIds");
    setGroups(resetGroupsCheckedArr);
    setCompanies(resetCompaniesCheckedArr);
    setSelectedGroups([]);
    setSelectedCompanies([]);
    setSelectedGroupIds([]);
    setSelectedCompanyIds([]);
    setDeviceIds([]);
  };

  const clearFileInput = id => {
    $(id).val("");
  };

  const handleDelegationSubmit = async () => {
    let hasGroupOrCompanySelected = !!(
      selectedCompanyIds.length < 1 && selectedGroupIds.length < 1
    );
    if (selectWay !== "upload") {
      // Check if Action is 'Assign' or 'Remove', is any group or company selected?
      if (action === "assign" || action === "remove") {
        setIsMissingSelectedTarget(hasGroupOrCompanySelected);
        if (hasGroupOrCompanySelected) {
          return;
        }
      }
    }
    try {
      dispatch({ type: "showLoading" });
      // Check if any device is selected
      let deviceIdsArr = await localforage.getItem("dtDeviceIds");
      let hasDeviceIdsArr = !!(deviceIdsArr && deviceIdsArr.length > 0);
      if (selectWay === "upload") {
        setExcelFile(!!excelFile);
      }
      if (selectWay !== "upload") {
        setDeviceIds(hasDeviceIdsArr);
      }

      // Submit
      if (excelFile || hasDeviceIdsArr) {
        if (selectWay === "upload" && excelFile) {
          // await uploadExistingDevicesAPI(
          //   action,
          //   selectedCompanyIds,
          //   selectedGroupIds,
          //   excelFile,
          //   deviceStatus,
          //   nubisVersion
          // );
          await uploadExistingDevicesAPI(excelFile);
          let successfulText = "setting.successfullyUploadExcel";

          successfullyDelegationHandling(
            t,
            getNotiDispatch,
            action,
            successfulText,
            "success",
            handleResetGroupsAndCompanys
          );
          clearFileInput("#fileInput");
        }

        if (selectWay !== "upload") {
          if (
            (action === "assign" || action === "remove") &&
            !hasGroupOrCompanySelected
          ) {
            if (action === "assign") {
              await assignDevicesAPI(
                deviceIdsArr,
                selectedGroupIds,
                selectedCompanyIds
              );
              let successfulText = "setting.successfullyAssignDevices";

              successfullyDelegationHandling(
                t,
                getNotiDispatch,
                action,
                successfulText,
                "success",
                handleResetGroupsAndCompanys
              );
            }
            if (action === "remove") {
              await removeDevicesAPI(
                deviceIdsArr,
                selectedGroupIds,
                selectedCompanyIds
              );
              let successfulText = "setting.successfullyRemoveDevices";

              successfullyDelegationHandling(
                t,
                getNotiDispatch,
                action,
                successfulText,
                "success",
                handleResetGroupsAndCompanys
              );
            }
          }

          if (action === "nubis_free" || action === "nubis_pro") {
            // 'action' already stated as nubis_free or nubis_pro, so just simply assigned it
            await updateDeviceNubisVersionAPI(deviceIdsArr, action);
            let successfulText = "setting.successfullyUpdateNubisStatus";

            successfullyDelegationHandling(
              t,
              getNotiDispatch,
              action,
              successfulText,
              "success",
              handleResetGroupsAndCompanys
            );
          }

          if (action === "register") {
            await updateDeviceStatusAPI(deviceIdsArr, "registered");
            let successfulText = "setting.successfullyRegisterDevices";

            successfullyDelegationHandling(
              t,
              getNotiDispatch,
              action,
              successfulText,
              "success",
              handleResetGroupsAndCompanys
            );
          }
        }
      }
    } finally {
      dispatch({ type: "stopLoading" });
    }
  };

  useEffect(() => {
    table(t);
    getAllSelectionItems(["group", "company"]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    handleResetGroupsAndCompanys();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editGroupsDialogOpen]);

  // // Datatable device selector
  // // Store the device Ids as an array in Localforage

  delegationTable.on("click", $("#device-list-table input"), async function () {
    handleDatatableSelectWithRadio(setSelectWay);
  });

  return (
    <Grid
      container
      spacing={2}
      className={`${classes.root} ${classes.delegationForm}`}
    >
      <Grid item xs={12}>
        <RadioGroup
          aria-label="selectWay"
          name="selectWay"
          value={selectWay}
          onChange={handleSelectWayChange}
        >
          <FormControlLabel
            value="select"
            control={<Radio color="primary" />}
            label={t("setting.selectDelegationSettings")}
          />
          <Grid item xs={12} style={{ marginBottom: 16 }}>
            <Paper elevation={0}>
              <Grid container alignItems="center">
                <Grid item xl={1} lg={2} md={2} sm={3} xs={3}>
                  <SettingText text="actions" />
                </Grid>
                <Grid item xl={11} lg={10} md={10} sm={9} xs={9}>
                  <ActionRadioGroup
                    action={action}
                    setResetSearchField={setResetSearchField}
                    selectedCompanyIds={selectedCompanyIds}
                    selectedGroupIds={selectedGroupIds}
                    deviceStatus={deviceStatus}
                    nubisVersion={nubisVersion}
                    setAction={setAction}
                    setNubisVersion={setNubisVersion}
                    handleReloadDataTable={handleReloadDataTable}
                    setIsMissingSelectedTarget={setIsMissingSelectedTarget}
                  />
                </Grid>
              </Grid>
              <Divider />
              <Grid container alignItems="center">
                <Grid item xl={1} lg={2} md={2} sm={3} xs={3}>
                  <DelegationActionFromOrToDeterminator
                    action={action}
                    actionsHideGroupOrTagSelection={
                      actionsHideGroupOrTagSelection
                    }
                  />
                </Grid>
                <Grid item xl={11} lg={10} md={10} sm={9} xs={9}>
                  <SelectionMenuItem
                    title="companies"
                    action={action}
                    actionsHideGroupOrTagSelection={
                      actionsHideGroupOrTagSelection
                    }
                    selectValueArray={selectedCompanies}
                    menuItemArray={companies}
                    checkBoxOnChange={e =>
                      handleItemsSelected(
                        e,
                        companies,
                        selectedCompanies,
                        "company"
                      )
                    }
                  />

                  {isMissingSelectedTarget && (
                    <Grid container spacing={2} alignItems="center">
                      <Grid item lg={2} md={2} sm={3} xs={3}></Grid>
                      <Grid item lg={10} md={10} sm={9} xs={9}>
                        <Box mb={1} mt={-1}>
                          <MissingSelectedErrorText text="selectedGroupOrCompanyRequired" />
                        </Box>
                      </Grid>
                    </Grid>
                  )}
                </Grid>
              </Grid>
            </Paper>
          </Grid>
          <DelegationTable
            resetSearchField={resetSearchField}
            setResetSearchField={setResetSearchField}
            reloadTableBtnOnclick={handleReloadDataTable}
          />
          <HasPermission permission="device_and_groups_import">
            <FormControlLabel
              value="upload"
              control={<Radio color="primary" />}
              label={t("setting.uploadDevicesSN")}
              style={{ marginTop: 16 }}
            />
            <Grid item xs={12}>
              <FormControl component="fieldset">
                <ExcelFileUpload
                  selectWay={selectWay}
                  excelFile={excelFile}
                  setExcelFile={setExcelFile}
                  setSelectWay={setSelectWay}
                />
                <Divider className={classes.divider} />
                {!deviceIds && (
                  <MissingSelectedErrorText text="selectedTargetRequired" />
                )}
              </FormControl>
            </Grid>
          </HasPermission>
        </RadioGroup>
      </Grid>
      <Grid item xs={12}>
        <div className={classes.formControlBtn}>
          <StyledSubmitBtn
            btnColor="primary"
            startIcon={<SendOutlined />}
            buttonClassname={classes.submitFormBtn}
            btnText={t("table.confirmBtn")}
            onClick={handleDelegationSubmit}
          />
          <Button color="secondary" variant="contained" href="/">
            {t("table.cancelBtn")}
          </Button>
        </div>
      </Grid>
      <EditGroupsDialog
        open={editGroupsDialogOpen}
        handleEditGroupsDialogClickOpen={handleEditGroupsDialogClickOpen}
        onClose={handleEditGroupsDialogClose}
      />
    </Grid>
  );
};

export default DelegationForm;
